export const FARE_DEFAULT = 'None';
export const FARE_FLEX = 'Flex';
export const FARE_SMART = 'Smart';